import { render, staticRenderFns } from "./crudPricesListsServices.vue?vue&type=template&id=2adc335d&"
import script from "./crudPricesListsServices.vue?vue&type=script&lang=js&"
export * from "./crudPricesListsServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports